import { Button, Grid } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import React,{useState,useRef} from 'react';
import toast from 'react-hot-toast';
import http from "../services/httpService"
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: "20px",
        marginBottom: 100
    },
    paper: {
        marginTop: 20,
        marginBottom: 100
    },
    lableColor: {
        color: "#393939",
        paddingTop: "5px",
        paddingLeft: "20px"
    },
    select: {
        height: 36,
        minWidth: 300,

    },
    radio: {
        '&$checked': {
            color: '#57bf74'
        }
    }, reviewButton: {
        borderRadius: "20px",
        border: "1px solid #2835D5",
        opacity: 1,
        textAlign: "right"
    },
    submitButton: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(10),


    },
    checked: {}
}));




function StockCloserUpload() {

    const classes = useStyles();
    const [fileUrl,setFileUrl]=useState(null);
    const [disable,setDisable] = useState(false);
    const fileInputRef = useRef(null)

    const handleFileUpload = (event) => {
        event.preventDefault();
        setFileUrl( event.target.files[0]);
    }
const submitFileUpload = (event)=>{
    event.preventDefault();
    setDisable(true)
    const formData = new FormData();
    toast.loading("Please wait..")

    if(fileUrl&&fileUrl.name){
        formData.append('data',fileUrl,fileUrl.name);
        http.post("/stockclosure",formData).then(res=>{
            setDisable(false)
            toast.dismiss()
            setFileUrl(null);
            if(res.data&&res.data.statusCode===0&&res.data.Data){
                toast.success(res.data.Data)
            }else{
                toast.error(res.data.Data)
            }
        }).catch(error=>{
            toast.dismiss()
            setDisable(false)
            setFileUrl( null)
            toast.error("Please upload valid file..!")
        })
    }else{
        toast.error('Please Upload file..!')
    }

}
    return (
        <div className={classes.root}>
            <Grid container component="main" style={{ marginTop: 30, marginBottom: 30 }}>
                <Grid item xs={false} sm={5} md={5} >
                    {/* <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={history.goBack}>Back</Button> */}
                </Grid>
                <Grid item xs={false} sm={5} md={5} >
                    <Typography  color="textPrimary" variant="h5" >Load Latest Rate</Typography>
                </Grid>

                <Grid container style={{ marginTop: 30 }}>
                    <Grid item xs={12} sm={2} md={2}>
                        <Typography  variant="h6" className={classes.lableColor}>Latest Rate</Typography>
                    </Grid>

                    <Grid item xs={12} sm={5} md={5} >
                    <input
                        ref={fileInputRef}
                        onChange={handleFileUpload}
                        type="file"
                        style={{ display: "none" }}
                        multiple={false}
                        accept=".xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    />
                        <Button startIcon={<AddCircleOutlineIcon />} variant="outlined" className={classes.reviewButton} color="primary" onClick={() => fileInputRef.current.click()}>Choose File</Button>
                        <span style={{ marginLeft: 10 }}>{fileUrl&&fileUrl.name?fileUrl.name:"No file chosen"}</span>
                    </Grid>
                </Grid>
                <Grid container className={classes.paper} style={{ marginTop: 30 }}>
                    <Grid item xs={12} sm={2} md={2}>
                    </Grid>

                    <Grid item xs={12} sm={5} md={5} >
                        <Button variant="contained" className={classes.reviewButton} color="primary" onClick={submitFileUpload} disabled={disable}>Load</Button>
                    </Grid>
                </Grid>

            </Grid>
        </div>
    )


}

export default StockCloserUpload;
